<template>
  <generic-modal :title="$t('sirc request')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column is-6">
          <div class="field">
            <generic-dropdown
              :title="$t('profile')"
              :placeholder="$t('profile')"
              url="/sirc/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_profile"
              ref="profile_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">{{ $t("request type") }}</label>
            <div class="select">
              <select v-model="meta.sirc_process_number">
                <option
                  v-for="request_type in request_types"
                  :value="request_type.sirc_code"
                >
                  {{ request_type.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <process11 v-show="meta.sirc_process_number == 11" ref="process_11" />
      <process12 v-show="meta.sirc_process_number == 12" ref="process_12" />
      <process13 v-show="meta.sirc_process_number == 13" ref="process_13" />
      <process16 v-show="meta.sirc_process_number == 16" ref="process_16" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import request_types from "../../sirc_request_types.json";
import Process11 from "./Process_11.vue";
import Process12 from "./Process_12.vue";
import Process13 from "./Process_13.vue";
import Process16 from "./Process_16.vue";

export default {
  name: "SircRequestModal",
  components: {
    GenericModal,
    GenericDropdown,
    Process11,
    Process12,
    Process13,
    Process16,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      profiles: [],
      request_types,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.profile_id || !v.meta.sirc_process_number;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(profile) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let reqst = { ...v.meta };
      if (v.meta.sirc_process_number == 11)
        reqst.data = v.$refs.process_11.get_data();
      else if (v.meta.sirc_process_number == 12)
        reqst.data = v.$refs.process_12.get_data();
      else if (v.meta.sirc_process_number == 13)
        reqst.data = v.$refs.process_13.get_data();
      else if (v.meta.sirc_process_number == 16)
        reqst.data = v.$refs.process_16.get_data();
      put("/sirc/request", reqst)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          console.log("error", error);
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
      };
      v.error = "";
      v.$refs.profile_dropdown.clear();
    },
    set_profile(profile) {
      if (profile) {
        let v = this;
        v.meta.profile_id = profile.profile_id;
      }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
